/**
 * TrendIndicator Komponente
 * Verwendet zentrale Score-Farben aus ui.config und Lucide Icons
 */

import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { TrendDirection } from '@/types';

interface TrendIndicatorProps {
  trend: TrendDirection;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

const trendConfig: Record<
  TrendDirection,
  { icon: typeof TrendingUp; label: string; className: string; textClass: string }
> = {
  up: {
    icon: TrendingUp,
    label: 'Aufwärtstrend',
    className: 'text-score-good bg-score-good-bg',
    textClass: 'text-score-good',
  },
  down: {
    icon: TrendingDown,
    label: 'Abwärtstrend',
    className: 'text-score-poor bg-score-poor-bg',
    textClass: 'text-score-poor',
  },
  stable: {
    icon: Minus,
    label: 'Stabil',
    className: 'text-charcoal-500 bg-charcoal-100',
    textClass: 'text-charcoal-500',
  },
};

const sizeStyles = {
  sm: { container: 'w-7 h-7', icon: 'w-4 h-4' },
  md: { container: 'w-8 h-8', icon: 'w-5 h-5' },
};

export function TrendIndicator({
  trend,
  size = 'md',
  showLabel = false,
}: TrendIndicatorProps): React.ReactElement {
  const config = trendConfig[trend];
  const sizes = sizeStyles[size];
  const Icon = config.icon;

  return (
    <div className="flex items-center gap-1.5">
      <div
        className={`
          ${sizes.container}
          ${config.className}
          rounded-lg flex items-center justify-center
        `}
        title={config.label}
      >
        <Icon className={sizes.icon} strokeWidth={2.5} />
      </div>
      {showLabel && (
        <span className={`text-sm ${config.textClass}`}>
          {config.label}
        </span>
      )}
    </div>
  );
}
